import { Button } from "@pushpress/pushpress-ui";
import { Column } from "@tanstack/react-table";
import { Triangle } from "lucide-react";
import { cn } from "../../../../utils/css";

export default function ColumnSortHeaderButton({
  column,
  title,
  hasRowsSelected,
}: {
  column: Column<any, unknown>;
  title: string;
  hasRowsSelected: boolean;
}) {
  if (hasRowsSelected) {
    return <div className="tw-w-full" />;
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      className="tw--ml-3 hover:tw-bg-transparent tw-gap-3 tw-flex tw-justify-between tw-px-0"
      onClick={() => column.toggleSorting(column.getIsSorted() !== "desc")}
    >
      <span className="tw-text-sm tw-font-semibold tw-text-neutral-800">
        {title}
      </span>
      <div className="tw-ml-auto tw-flex tw-flex-col tw-h-4 tw-w-4 tw-gap-0.5 tw-mt-1">
        <Triangle
          className={cn(
            "tw-ml-auto tw-h-1.5 tw-w-4 tw-text-neutral-400 tw-fill-neutral-400",
            column.getIsSorted() === "asc" &&
              "!tw-text-neutral-800 !tw-fill-black",
          )}
        />
        <Triangle
          className={cn(
            "tw-ml-auto tw-h-1.5 tw-w-4 tw-text-neutral-400 tw-fill-neutral-400 tw-rotate-180",
            column.getIsSorted() === "desc" &&
              "!tw-text-neutral-800 !tw-fill-black",
          )}
        />
      </div>
    </Button>
  );
}
